import { Route, Routes } from 'react-router-dom';
import Banner from './Pages/Banner';
import 'swiper/css';
import Main from './Pages/Main';
import Contact1 from './Pages/Contact1';
import ServicePage from './Pages/ServicePage';
import Services from './Pages/Services';
import ScrollToHash from './ScrollToHash';

function App() {
  return (
    <div className="App">
      <Routes>
        {/* Public routes */}
        <Route exact path="/" element={<Contact1 />} />
        {/* <Route exact path="/contact" element={<Contact1 />} /> */}
        {/* <Route exact path="/service" element={<Services />} /> */}
        
      </Routes>
        {/* <ScrollToHash /> */}
    </div>
  );
}

export default App;
